import { render } from "./ExclamationIcon.vue?vue&type=template&id=6fa54b66&scoped=true&ts=true"
import script from "./ExclamationIcon.vue?vue&type=script&lang=ts"
export * from "./ExclamationIcon.vue?vue&type=script&lang=ts"

import "./ExclamationIcon.vue?vue&type=style&index=0&id=6fa54b66&scoped=true&lang=scss"

import exportComponent from "/srv/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fa54b66"]])

export default __exports__